type Meridian = 'AM' | 'PM';
export enum MeridianInfo {
	AM = 'AM',
	PM = 'PM'
}

export interface ScheduleWindow {
	hours: number;
	minutes: number;
	meridian: Meridian;

	durationHours: number;
	durationMinutes: number;
	selectedDays: number[];

	invalidFields?: {
		hours?: boolean;
		minutes?: boolean;
		durationHours?: boolean;
		durationMinutes?: boolean;
		days?: boolean;
	};
}